<template>
    <div class="navBox" >
        <div class="mainNav" >
            <div class="logoBox"><img src="@/assets/images/logo.png" alt="" width="100%"></div>
            <div class="listBox">
                <ul>
                    <li :class="pagetype=='index'?'active':''"><router-link to="/">首页</router-link></li>
                    <li :class="pagetype=='hot'?'active':''"><router-link to="/list?type=hot">热门</router-link></li>
                    <!-- <li >语聊</li> -->
                    <li :class="pagetype=='new'?'active':''"><router-link to="/list?type=new">最新</router-link></li>
                    <li :class="pagetype=='attention'?'active':''" @click="onClickAttention">关注</li>
                    <!-- <li v-if="Pid != 152"><a href="javascript:void(0);" @click="toAddU">充值</a></li> -->
                    <li class="uaddstyle" ><a href="javascript:void(0);" @click="toAddU">充值</a></li>
                    <!-- <li>排行</li> -->
                </ul>
            </div>
            <div class="searchBox">
                <input type="text" placeholder="请输入用户ID" id="search" @keypress.enter='onClickSearch'  v-model="searchKey">
                <div class="searchBtn" @click="onClickSearch"></div>
            </div>
            <div class="loginRegBox" v-show="!userInfo.photo_num">
                <div class="loginBtn" @click="showLoginReg(1)">登录</div>
                <div class="line"></div>
                <div class="regBox" @click="showLoginReg(2)">注册</div>
            </div>
            <div class="loginMsg" v-show="login">
                <img :src="imgsrc" @error="defaultPic($event)">
                <logincard class="userCard"></logincard>
                <a href="javascript:void(0);" @click="exit">退出</a>
            </div>
        </div>
    </div>
</template>
<script>
import logincard from "@/components/loginUserCard";
export default {
    name:"navBox",
    components:{logincard},
    props:['type','pagetype'],
    mounted() {
    },
    data(){
        return {
            searchKey:'',
        };
    },
    methods: {
        toAddU(){
            // if(this.userInfo.photo_num){
            //     var str='reg_mac='+localStorage.getItem('mac')+'&nick_nm='+encodeURIComponent(this.userInfo.nick_nm)+'&token='+this.$store.state.loginUserInfo.token+'&user_id='+this.userInfo.user_id;
            //     window.open('http://pay.fengbolive.com/userinfo/site/webpc.html?'+str);
            // }else{
            //     window.open('http://pay.fengbolive.com/userinfo/site/webpc.html');
            // }
            window.open('/pay')
        },
        toAgent () {
            if(this.userInfo.photo_num){
                var str='reg_mac='+localStorage.getItem('mac')+'&nick_nm='+encodeURIComponent(this.userInfo.nick_nm)+'&token='+this.$store.state.loginUserInfo.token+'&user_id='+this.userInfo.user_id;
                window.open('http://agent.fengbolive.com/?'+str);
            }else{
                window.open('http://agent.fengbolive.com/');
            }
        },
        showLoginReg(index){
			this.$store.dispatch('upDataLoginRegCloseBtnShowBool',true);
            this.$store.dispatch('upDataLoginRegShowBool',index)
        },
        exit(){
            this.$common.delCookie('userInfo');
            //this.$common.delCookie('FENGBO','/','.fengbolive.com');
            //this.$common.delCookie('FENGBOZHIBO','/','.fengbolive.com');
            //this.$common.delCookie('FENGBO','/','.live.sinashow.com');
            //this.$common.delCookie('FENGBOZHIBO','/','.live.sinashow.com');
            this.$parent.$parent.visiterLogin();
        },
        defaultPic(event){
            this.$common.defaultPic(event);
        },
        onClickAttention(){
            if (!this.login) {
                this.showLoginReg(1);
            }else{
                let param = { path: "/list?type=attention" };
                this.$router.push(param);
            }
        },
        onClickSearch(){
            this.$store.commit('SEARCH_RESULT_UPDATE_KEY', this.searchKey);
            this.searchKey = '';
            let param = { path: "/list?type=search" };
            this.$router.push(param);
        },
        onOpenUrl(){
            window.open('http://live.fengbolive.com/index.html');
        }
    },
    computed:{
        userInfo(){
            if(this.$store.state.loginUserInfo.info){
                return this.$store.state.loginUserInfo.info
            }else if(sessionStorage.getItem('userInfo')){
                return JSON.parse(sessionStorage.getItem('userInfo'));
            }else{
                return {nick_nm:'游客',photo_num:''}
            }
        },
        imgsrc(){
            if(this.userInfo.photo_num){
                return this.$common.getPhotoUrl(this.userInfo.user_id,this.userInfo.photo_num,2);
            }else{
                return '';
            }
        },
        login(){
            if(this.userInfo.photo_num){
                return true
            }else{
                return false
            }
        },
        isFromClient(){
            let client = localStorage.getItem('client');
            return client == 'pc';
        },
        Pid(){
            return this.$store.state.loginUserInfo.pid;
        }
    }
}
</script>
<style scoped>
.navBox{ width: 100%; background: #fff;}
.mainNav{height: 60px; display: flex; align-items: center; flex-direction: row; margin: 0 auto; padding: 0px 50px 0px 50px; min-width: 1200px; max-width: 1330px;}
.mainNav.listType{width: 100%; padding: 0 95px; box-sizing: border-box;}
.mainNav .logoBox{ width: 140px; margin-right: 46px;}
.mainNav .listBox{flex: 1 1 auto;}
.mainNav ul{ display: flex; justify-content: flex-start; font-size: 18px; }
.mainNav li{ margin-right: 30px; cursor: pointer}
.mainNav li,
.mainNav li a
 {color: #333;}
 
.mainNav .uaddstyle{
     color: #ffffff;
     width: 68px;
     height: 28px;
     border-radius: 14px;
     background: linear-gradient(123deg, #ad66ea, #7c46e8);
     margin-top: -1px;
}
.mainNav .uaddstyle a{
     display:block;
     line-height: 28px;
     color: #ffffff;
     text-align: center;
     font-size: 16px;
     width: 68px;
     height: 28px;

}
.mainNav .uaddstyle:hover{
     color: #ffffff;
}
.mainNav .uaddstyle:hover a{
     color: #ffffff;
}
.mainNav li:hover,
.mainNav li:hover a
{color: #8d5eeb;}
.mainNav li.active,
.mainNav li.active a
{ color: #7c46e8;}
.mainNav .searchBox{ width: 220px; height: 30px; border: 1px #e0e0e0 solid; border-radius: 15px; box-sizing: border-box; overflow: hidden; position: relative;}
.mainNav .searchBox #search{ width: 100%; height: 100%; padding:0 42px 0 12px; box-sizing: border-box; line-height: 30px;}
.mainNav .searchBox .searchBtn{ position: absolute; width: 30px; height: 30px; background: url("~@/assets/images/searchIcon.png") center center no-repeat; right: 3px; top: 0px; cursor: pointer;}

.mainNav .downLoadBox{position: relative; margin-left: 25px;}
.mainNav .downLoadBtn{ width: 133px; height: 33px; line-height: 33px; border-radius: 15px; border-color: #7c46e8; border-style: solid; border-width: 1px; color: #7c46e8; box-sizing: border-box; padding-left: 23px; background: url("~@/assets/images/downIcon.png") no-repeat 94px center #fff; cursor: default; font-size: 17px;}

.mainNav .downLoadBox:hover .downLoadSon{display: flex}

.mainNav .downLoadSon{ position: absolute; width: 377px; height: 176px; background: #fff; border-radius: 8px; border: 1px solid #c9c9c9; box-sizing: border-box; padding: 0px 0px 0px; left: -116px; top:41px; display: none; z-index: 99}
.mainNav .downLoadSon::after{ content: ""; background: url("~@/assets/images/topIcon.png") no-repeat center center; width: 100%; height: 13px; position: absolute; top:-12px; left: 0;}

.mainNav .downLoadPcBtn{ width: 142px; height: 30px; line-height: 30px; color: #fff; background: url("~@/assets/images/pcIcon.png") no-repeat 20px center #7c46e8; padding-left: 43px; box-sizing: border-box; border-radius: 5px; margin: 0 auto; font-size: 14px; display: block;}

.mainNav .downLoadMbTitle{color: #666; font-size: 14px; height: 48px; box-sizing: border-box; border-top:1px solid #f8f8f8; background: url("~@/assets/images/iphoneIcon.png") 4px center no-repeat; line-height: 48px; padding-left: 28px; border-bottom:1px solid #f8f8f8; width: 110px; margin: 6px auto 0;}
.mainNav .downLoadMbCode{ width: 160px; height: 160px; margin: 7px 0px 0px 11px}
.mainNav .downLoadMbCode img{width:100%;height:100%}
.mainNav .downLoadButtonR{margin-left: 8px; margin-top: 8px;height:100%; width:190px; display: flex; flex-wrap:wrap}
.mainNav .downLoadButtonR .iPhoneDownload{width:90px; height:70px; background-image: url('~@/assets/images/ios_normal.png');cursor: pointer;}
.mainNav .downLoadButtonR .iPhoneDownload:hover{background-image: url('~@/assets/images/ios_hover.png')}

.mainNav .downLoadButtonR .AndroidDownload{width:90px; height:70px; background-image: url('~@/assets/images/android_normal.png'); margin-left: 9px; cursor: pointer;}
.mainNav .downLoadButtonR .AndroidDownload:hover{background-image: url('~@/assets/images/android_hover.png')}

.mainNav .downLoadButtonR .PcDownload{width:90px; height:70px; background-image: url('~@/assets/images/pc_normal.png'); cursor: pointer;}
.mainNav .downLoadButtonR .PcDownload:hover{background-image: url('~@/assets/images/pc_hover.png')}
.mainNav .downLoadButtonR .MacDownload{width:90px; height:70px; background-image: url('~@/assets/images/mac_normal.png'); margin-left: 9px; cursor: pointer;}
.mainNav .downLoadButtonR .MacDownload:hover{background-image: url('~@/assets/images/mac_hover.png')}

.loginRegBox{ width: 120px; height: 32px;box-sizing: border-box; border: 1px solid #7c46e8; color: #7c46e8; border-radius: 15px; overflow: hidden; font-size: 14px; display: flex; justify-content: space-around; align-items: center; margin-left: 20px;}
.loginRegBox .line{ height: 10px; background: #7c46e8; width: 1px;}
.mainNav .loginBtn,.mainNav .regBox{ width: 56px; text-align: center; cursor: pointer;}
.loginMsg{margin-left:20px;  position: relative; }
.loginMsg img{width:40px;height:40px;vertical-align:middle;margin-right:10px;border-radius:50%;}
.loginMsg a{font-size:14px;line-height:60px;color:#002ee0d6}
.loginMsg .userCard{display: none;  position: absolute; left: -100px; top:60px; z-index: 100}
.loginMsg:hover .userCard{display: block}
</style>
